import { render } from "./SendDetails.vue?vue&type=template&id=3cc2487c"
import script from "./SendDetails.vue?vue&type=script&lang=js"
export * from "./SendDetails.vue?vue&type=script&lang=js"

import "./SendDetails.vue?vue&type=style&index=0&id=3cc2487c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__